export const phoneNormalization = (phonenumber) => {
  const withoutAreaCode = phonenumber.replace("+358", "");

  if (withoutAreaCode.startsWith("0")) {
    return "+358" + withoutAreaCode.replace("0", "");
  }

  return phonenumber;
};
